import * as React from 'react';
import {
    Edit,
    ReferenceInput,
    SelectInput,
    AutocompleteInput,
    SaveButton,
    useNotify,
    useRedirect,
    useRecordContext,
    Toolbar
} from 'react-admin';
import { codesFields, CodeTypeChoices } from '../codes.model';
import { orgsFields } from '../../organizations/orgs.model';
import { ALL_ORGANIZATIONS_RESOURCE_NAME as ORGANIZATIONS_RESOURCE } from '../../organizations/organizations.dataProvider';
import ProviderRoleOrderedList from '../../components/ProviderRoleOrderedList';
import { validateCodeName, validateOrganization, validateCodeType } from './utils/codeValidators';
import CodeInput from './fields/CodeInput.component';
import { ORGANIZATION_DROPDOWN_PERPAGE } from '../../utils/constants';
import { SectionedForm } from '../../components/layouts';

const EditToolbar = () => (
    <Toolbar>
        <SaveButton 
            label="Save"
            sx={{ marginLeft: 2 }}
        />
    </Toolbar>
);

const RolesList = () => {
    const record = useRecordContext();
    if (!record) return null;

    return (
        <ProviderRoleOrderedList 
            rolesFieldName={codesFields.roleIds}
            record={record}
        />
    );
};

const CodeEdit = () => {
    const notify = useNotify();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify('Code updated successfully', { type: 'success' });
        redirect('show', 'codes', data.id);
    };

    const onError = (error) => {
        notify(`Error: ${error.message}`, { type: 'error' });
    };

    const sections = [
        {
            title: "Code Details",
            fields: [
                <CodeInput 
                    key="codeName"
                    source={codesFields.codeName} 
                    label="Code Name" 
                    editMode={true}
                />,
                <ReferenceInput 
                    key="organization"
                    source={codesFields.orgId}
                    reference={ORGANIZATIONS_RESOURCE} 
                    label="Organization"
                    perPage={ORGANIZATION_DROPDOWN_PERPAGE}
                    sort={{ field: 'name', order: 'ASC' }}
                >
                    <AutocompleteInput 
                        optionText={orgsFields.orgName}
                        validate={validateOrganization}
                    />
                </ReferenceInput>,
                <SelectInput 
                    key="codeType"
                    label="Code Type"
                    source={codesFields.codeType}
                    validate={validateCodeType}
                    choices={CodeTypeChoices}
                />
            ]
        },
        {
            title: "Configuration",
            fields: [
                <RolesList key="rolesList" />
            ]
        }
    ];

    return (
        <Edit
            title="Edit Membership Code"
            mutationMode="pessimistic"
            mutationOptions={{ 
                onSuccess,
                onError
            }}
            sx={{
                '& .RaEdit-main': {
                    margin: '0.5em'
                }
            }}
        >
            <SectionedForm
                sections={sections}
                toolbar={<EditToolbar />}
                mode="onBlur"
            />
        </Edit>
    );
};

export default CodeEdit;
